var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepsRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7422 14.1407L9.87416 12.6095C8.69023 12.5444 7.67936 13.4018 7.61631 14.5245L6.47472 34.8528C6.41167 35.9755 7.32033 36.9383 8.50426 37.0034L36.3723 38.5346C37.5562 38.5996 38.5671 37.7422 38.6302 36.6195L39.7717 16.2913C39.8348 15.1686 38.9261 14.2057 37.7422 14.1407Z",
    fill: "#4D8DF4",
    stroke: "#606060",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7337 23.1268C16.9177 23.1918 17.9285 22.3345 17.9916 21.2118C18.0546 20.0891 17.146 19.1262 15.9621 19.0611C14.7781 18.9961 13.7672 19.8535 13.7042 20.9762C13.6412 22.0989 14.5498 23.0617 15.7337 23.1268Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7416 23.9513C31.9255 24.0163 32.9364 23.1589 32.9994 22.0362C33.0625 20.9135 32.1538 19.9507 30.9699 19.8856C29.7859 19.8206 28.7751 20.6779 28.712 21.8006C28.649 22.9233 29.5576 23.8862 30.7416 23.9513Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7199 27.3692C17.5359 27.3042 16.5251 28.1616 16.462 29.2843C16.399 30.407 17.3076 31.3698 18.4916 31.4349L18.7199 27.3692ZM27.0663 31.906C28.2503 31.9711 29.2611 31.1137 29.3242 29.991C29.3872 28.8683 28.4786 27.9054 27.2947 27.8404L27.0663 31.906ZM18.4916 31.4349L27.0663 31.906L27.2947 27.8404L18.7199 27.3692L18.4916 31.4349Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2617 5.24341L23.8051 13.3747",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91406 20.3284L1.45743 28.4596",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7871 22.6841L44.3305 30.8153",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.265 5.24349C25.4489 5.30855 26.4598 4.45115 26.5228 3.32845C26.5859 2.20575 25.6772 1.24289 24.4933 1.17784C23.3094 1.11279 22.2985 1.97019 22.2355 3.09288C22.1724 4.21558 23.0811 5.17844 24.265 5.24349Z",
    stroke: "#606060",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsRobot);
export default __webpack_public_path__ + "static/media/steps_robot.3d0fbb4cf6365db44d4cc6940c24a29b.svg";
export { ForwardRef as ReactComponent };